import React, { useEffect, useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { Table, TableBody, TableCell, TableRow } from '@mui/material';
import useQuery from './useQuery';
import RequestBiosamplesButton from './RequestBiosamplesButton';
import EnodBeaconClient from "../../clients/EnodBeaconClient";


function BiosamplesCounter() {
    const [numBiosamples, setNumBiosamples] = useState(undefined as number | undefined);
    const query = useQuery();

    useEffect(() => {
        const abortController = new AbortController();
        const options = {
            method: 'GET',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json'
            },
            signal: abortController.signal
        } as RequestInit;
        (async () => {
            try {
                const numBiosamples = await EnodBeaconClient.countBiosamples(query, abortController.signal);
                setNumBiosamples(numBiosamples);
            } catch (error) {
                if (!abortController.signal.aborted) {
                    // error!
                    console.log("ERROR: " + error);
                }
            }
        })();
        return () => {
            abortController.abort();
        };
    }, [query]);

    return (
        <div>
            <Table>
                <TableBody>
                    <TableRow>
                        <TableCell>Number of biosamples:</TableCell>
                        <TableCell>{undefined === numBiosamples ? <CircularProgress /> : <span>{numBiosamples}</span>}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            {!!numBiosamples && numBiosamples < 100 && <RequestBiosamplesButton />}
        </div>
    );
}


export default BiosamplesCounter;
